import { apiEndpoint } from '../../config/app';
import createRestApiClient from '../utils/createRestApiClient';

export default () =>{
    const client = createRestApiClient().withConfig({ baseURL: apiEndpoint });
    return {
        getFiles: (websiteId) => client.request({
            method: 'GET',
            url: `/files/${websiteId}`
        }),
        uploadFile: (file, websiteId) => client.request({
            method: 'POST',
            url: `/website/${websiteId}/file/${file.id}`,
            data: file.data
        }),
        deleteFile: (id) => client.request({
            method: 'DELETE',
            url: `/website/file/${id}`
        })
    };
};


// WEBPACK FOOTER //
// app/services/files.js